import { Link } from 'react-router';

import { Button } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { breakpoints } from 'styles/theme.variables';

import { SUPPORT_URL } from 'constants/chownow';
import { ERROR_PAGE_BUTTONS } from 'constants/error';

import { useAuth } from 'hooks/useAuth';

const ERROR_BUTTON_PATHS = {
  [ERROR_PAGE_BUTTONS.contactSupport]: SUPPORT_URL,
  [ERROR_PAGE_BUTTONS.logout]: '/login',
  [ERROR_PAGE_BUTTONS.goToLogin]: '/login',
  [ERROR_PAGE_BUTTONS.goToOverview]: '/',
  [ERROR_PAGE_BUTTONS.backToHq]: '/',
  // ProtectedLayout appends the hqId
  [ERROR_PAGE_BUTTONS.startExploring]: '/',
};

interface ErrorButtonProps {
  label: string;
  fullWidth?: boolean;
}

export default function ErrorButton({ label, fullWidth = false }: ErrorButtonProps) {
  const auth = useAuth();

  const isMobile = useMediaQuery(`(max-width: ${breakpoints.maxMobile})`);

  if ([ERROR_PAGE_BUTTONS.goToLogin, ERROR_PAGE_BUTTONS.logout].includes(label) && auth?.logout) {
    return (
      <Button fullWidth={isMobile || fullWidth} onClick={auth.logout}>
        {label}
      </Button>
    );
  }

  if (label === ERROR_PAGE_BUTTONS.contactSupport) {
    return (
      <Button
        component="a"
        href={ERROR_BUTTON_PATHS[label]}
        target="blank"
        fullWidth={isMobile || fullWidth}
      >
        {label}
      </Button>
    );
  }

  return (
    <Button to={ERROR_BUTTON_PATHS[label]} fullWidth={isMobile || fullWidth} component={Link}>
      {label}
    </Button>
  );
}
